import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { AnimatePresence, motion } from 'framer-motion';
import { useMeasure } from "../../hooks";
import { eases } from "../../motion/eases";
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { theme } from "../../theme";
var transition = {
  ease: eases.primary,
  duration: 0.3
};
var animationVariants = {
  collapsed: {
    height: 0,
    opacity: 0,
    transition: transition
  },
  open: {
    height: 'auto',
    opacity: 1,
    transition: transition
  }
};
export function AnimatedHeight(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 'auto' : _ref$height,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? animationVariants : _ref$variants,
      _ref$isShowing = _ref.isShowing,
      isShowing = _ref$isShowing === void 0 ? true : _ref$isShowing,
      _ref$initial = _ref.initial,
      initial = _ref$initial === void 0 ? false : _ref$initial,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["height", "variants", "isShowing", "initial", "children"]);

  var _useMeasure = useMeasure(),
      _useMeasure2 = _slicedToArray(_useMeasure, 2),
      ref = _useMeasure2[0],
      bounds = _useMeasure2[1];

  var styles = useMemo(function () {
    if (height === 'auto') {
      if (bounds.x) {
        return {
          height: "".concat(bounds.height, "px")
        };
      }

      return {
        height: 'auto'
      };
    }

    return {
      height: height
    };
  }, [bounds.height, bounds.x, height]);
  return /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: initial
  }, isShowing && /*#__PURE__*/React.createElement(motion.div, {
    variants: variants,
    initial: "collapsed",
    animate: "open",
    exit: "collapsed"
  }, /*#__PURE__*/React.createElement(AnimatedContainer, _extends({
    style: styles
  }, other), /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, children))));
}
var transitions = theme.transitions;
var AnimatedContainer = styled.div.withConfig({
  displayName: "AnimatedHeight__AnimatedContainer",
  componentId: "vapor__rasxrd-0"
})(["overflow:hidden;transition:height ", " ", ";"], transitions.durations[300], transitions.eases.primary);